import { render, staticRenderFns } from "./MLsportSpecialCart.vue?vue&type=template&id=6065dfa4&scoped=true"
import script from "./MLsportSpecialCart.vue?vue&type=script&lang=js"
export * from "./MLsportSpecialCart.vue?vue&type=script&lang=js"
import style0 from "./MLsportSpecialCart.vue?vue&type=style&index=0&id=6065dfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065dfa4",
  null
  
)

export default component.exports